export default __webpack_public_path__ + "static/media/website-service.c3af02ce.jpeg";